import { Directive } from "vue";
import { Tooltip } from "bootstrap";
const tooltip: Directive = {

    mounted(el, binding) {
        new Tooltip(el, { title: binding.value })
    },
    updated(el, binding) {

        let ins = Tooltip.getInstance(el);
        if (ins) {
            ins.dispose();
        }
        new Tooltip(el, { title: binding.value })
    },
    beforeUnmount(el, binding) {
        let ins = Tooltip.getInstance(el);
        if (ins) {
            ins.dispose();
        }
    }
}

export default tooltip;